import { AutoMap } from "@automapper/classes"

export class Agency {
    public constructor(init?: Partial<Agency>) {
        Object.assign(this, init);
    }

    @AutoMap()
    Name!: string;
    @AutoMap()
    Email!: string;
    @AutoMap()
    DispatchEmail!: string;
    @AutoMap()
    PartnerCode!: string;
    @AutoMap()
    AnalyticalUnitCode!: string;
    @AutoMap()
    Address!: string;
    @AutoMap()
    ZipCode!: string;
    @AutoMap()
    City!: string;
    @AutoMap()
    Phone!: string;
    @AutoMap()
    PartnerName!: string;

}